import { TitleSection } from "../title-section";
import BrazilMapChart from "./brazil-chart";

export const InterestsPerState = () => {
  return (
    <section id="interesses" className="py-10 mx-4 lg:mx-0 flex justify-center">
      <div className="relative w-full lg:max-w-screen-xl 2xl:max-w-screen-2xl">
        <div className="flex flex-col items-center p-4">
          <TitleSection
            blueToRed
            first_title="Interesses por estado"
            description="O Brasil está em constante busca por informações relacionadas ao ENEM, especialmente quando o assunto são as questões de Humanas. "
          />
          <div className="flex flex-col lg:flex-row items-center lg:items-start justify-center gap-8 w-full">
            <div className="lg:absolute bottom-40 left-10 max-w-xs ">
              <h1 className="text-3xl text-[#1f9d55]">Geografia</h1>
              <p className="text-sm text-gray-600">
                Cerca de 96,3% das pesquisas feitas no Google sobre o Enem são
                relacionadas à Geografia.
              </p>
            </div>

            {/* Mapa */}
            <div className="w-full">
              <BrazilMapChart />
            </div>
            <div className="lg:absolute bottom-52 right-4 max-w-xs">
              <h1 className="text-3xl text-[#ffeb3b]">História</h1>
              <p className="text-sm text-gray-600">
                Somente no estado do Amapá, a História domina as pesquisas no
                Google.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-6 text-xs text-gray-500 text-right w-full px-4 lg:px-0">
          Fonte: Dados extraídos do Google Trends com base nas pesquisas
          relacionadas ao ENEM (2023).
        </div>
      </div>
    </section>
  );
};
